"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = LabelSingle;
var propTypes = {};
var defaultProps = {};

function LabelSingle(props) {
  var selectedOptions = props.selectedOptions,
      options = props.options;
  var option = options[selectedOptions[0]];

  if (option.label) {
    return option.label;
  }

  if (typeof options.content === "string") {
    return option.content;
  }

  console.log("Warning: Your Option required a label prop, <ListBox.Option label='your label' /><MyCoolContent /></ListBox.Option>");
  return option.content;
}

LabelSingle.propTypes = propTypes;
LabelSingle.defaultProps = defaultProps;
//# sourceMappingURL=LabelSingle.js.map